import { render, staticRenderFns } from "./order-status.vue?vue&type=template&id=03604274&scoped=true&lang=html&"
import script from "./order-status.vue?vue&type=script&lang=js&"
export * from "./order-status.vue?vue&type=script&lang=js&"
import style0 from "./order-status.vue?vue&type=style&index=0&id=03604274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03604274",
  null
  
)

export default component.exports